<template>
    <div>
        <div class="listingPageTitle">
            <h1>Media Property Maintenance</h1>
            <ItemModal :itemName="'Media Property'"
                            :formRows="newMediaPropertyFormRows"
                            :saveItemFunction="newRecord"
                            :refreshItemsFunction="loadRecords"></ItemModal>
        
        </div>
        <div class="searchContainer">
            <div style="display:flex; flex-direction: row; width: 80%; padding-left: 0px; padding-right: 0px">
                <div class="formRow flexColumn"><span class="inputTitle">Search Name: </span><input type="text" v-model="searchText" style="width:250px" /></div>
                <div class="formRow flexColumn"><span class="inputTitle">Type: </span>
                    <Multiselect style="width:250px"
                                v-model="searchTypes"
                                :options="mediaPropertyTypes"
                                track-by="value"
                                select-label=''
                                selected-label=''
                                deselect-label=''
                                label="displayName"
                                placeholder="Type to search"
                                open-direction="bottom"
                                :multiple="true"
                                :searchable="true"></Multiselect>
                </div>
                <div class="formRow"><span class="inputTitle">Active Only: </span><input type="checkbox" v-model="onlyShowActive" /></div>
            </div>
        </div>
        <hr />
        <ListingTable :columns="columns" :filterCriteria="filterCriteria" :actions="actionMappings" 
            :key="componentKey" :intitializationParameters="{ sortBy: 'id', sortDirection: 'desc' }" ref="listingTable"/>
    </div>
</template>

<script>
import {data} from '../../shared/data';
import ItemModal from '@/components/ItemModal.vue';
import ListingTable from '@/components/shared/ListingTable.vue';
import {sorting} from '@/shared/sorting';
import Multiselect from 'vue-multiselect';

export default {
    name: 'MediaProperties',
    components: {ItemModal, ListingTable, Multiselect},
    data: function() {
        return {
            mediaProperties: [],
            searchText: "",
            searchTypes: [],
            onlyShowActive: true,
            componentKey: 0,
            mediaPropertyTypes: [],
            columns: [ 
                {
                    headerDisplayName: "ID",
                    width: "10%",
                    fieldName: "id"
                },
                {
                    headerDisplayName: "Description",
                    width: "60%",
                    fieldName: "description",
                    isEditLink: true
                },
                {
                    headerDisplayName: "Media Type",
                    width: "15%",
                    fieldName: "mediaType"
                },
                {
                    width: "10%",
                    columnType: "buttons",
                    showDeleteFieldName: "isActive",
                    showUndeleteFieldName: "!isActive",
                    showCopyFieldName:'isActive'
                }
            ],
            newMediaPropertyFormRows: [
                {
                    name: 'Media Type',
                    propertyName: 'mediaType',
                    required: true,
                    element: 'select'
                },
                {
                    name: 'Description',
                    propertyName: 'description',
                    required: false,
                    element: 'textarea'
                }
            ],
            actionMappings: {
                onLoadData: this.loadRecords,
                onDelete: this.deleteRecord, 
                onUndelete: this.reactivateRecord,
                editHrefBuilder: this.editHrefBuilder,
                onCopy: this.copyRecord
            }
        }
    },
    computed: {
        filterCriteria () {
            var criteria = [];
            if(this.searchText != "") 
                criteria.push( {
                    dataType: "String",
                    fieldName: "description",
                    value: this.searchText
                });

            if(this.onlyShowActive) {
                criteria.push( {
                    dataType: "Boolean",
                    fieldName: "isActive",
                    value: true
                });
            }

            if(this.searchTypes.length > 0)
                criteria.push( {
                    dataType: "String",
                    fieldName: "mediaType",
                    value: this.searchTypes.map(obj => obj.internalName)
                });
            
            return criteria;
        }
    },
    mounted() {
        this.getMediaPropertyTypes();
    },
    methods: {
        loadRecords: async function() {
            return await data.getAllMediaProperties(this.searchText, false);
        },
        newRecord: async function(mp) {
            this.$router.push({
                name: 'MediaPropertyEdit',
                query: {
                    mediaType: mp.mediaType,
                    description: mp.description
                }
            });
        },
        saveMediaProperty: async function(mp, redirectToEditFlag) {
            var retObject = this.processSaveResult(await data.saveMediaProperty(mp));

            if(retObject.success) {
                if(redirectToEditFlag && retObject.id) {
                    mp.id = retObject.id;
                    window.location.href = this.editHrefBuilder(mp);
                }
                else 
                    return retObject;
            }
            else
                return retObject;
        },
        editHrefBuilder: function(mp) {
          return '/MediaPropertyEdit?ID=' + mp.id ;
        },
        deleteRecord: async function(mp) {
            if(confirm('Are you sure you want to delete this media property?')) {
                var status = this.processDeactivateResult(await data.deleteMediaProperty(mp.id));
                if(status.success) 
                    mp.isActive = false;
            }
        },
        reactivateRecord: async function(mp) {
            mp.isActive = true;
            var status = await this.saveMediaProperty(mp, false);
            if(!status.success)
                mp.isActive = false;
        },
        getMediaPropertyTypes: async function() {
            this.mediaPropertyTypes = await data.getEnumList("MediaTypes");
            this.mediaPropertyTypes = this.mediaPropertyTypes.filter(search => search.displayName != "NotSet");
            this.mediaPropertyTypes = sorting.sortArray(this.mediaPropertyTypes, "displayName", "asc", 0, 0);        
            this.newMediaPropertyFormRows.find(row => row.propertyName == 'mediaType').selectOptions = this.mediaPropertyTypes;
        },
        copyRecord: async function(mp) {
            if(confirm(`Are you sure you want to copy the "${mp.description}" media property?`)) {
                await data.copyMediaProperty(mp.id);
                this.$refs.listingTable.getRecords();
                this.$toast.success('Copy Saved');
            }
        }
    }
}
</script>

<style scoped>
    :deep(.multiselect__option) {
        padding: 5px 12px !important;
        min-height: unset !important;
    }
</style>